import { Button } from "@/components/ui/baseUi/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/baseUi/dropdown-menu"
import { word } from "@/modules/core/utils/i18n"
import { ExportModal } from "@/modules/finances/components/exportModal"
import { UserPromotionCodeCard } from "@/modules/finances/components/promotionCodeCard"
import { TransactionsMyWalletCard } from "@/modules/finances/components/transactionsMyWalletCard"
import { TransactionsResumeCard } from "@/modules/finances/components/transactionsResumeCard"
import { useDownloadAllMonthlyInvoices } from "@/modules/finances/hooks/useFinanceActions"
import { TransactionTableFilter } from "@/modules/finances/transactions/components/transactionTableFilter"
import { UserTransactionsTable } from "@/modules/finances/transactions/components/userTransactionsTable"
import { ApiFinanceType } from "@/modules/finances/types/financesType"
import { cn } from "@/modules/lib/utils"
import { LoadingSpinner } from "@/modules/ui/components/loading"
import { ChevronDownIcon, DownloadIcon } from "lucide-react"
import { Suspense, useState } from "react"

export type UserPayinLayoutProps = {
  className?: string
} & React.ComponentProps<"div">

export function UserPayinLayout({ className, ...props }: UserPayinLayoutProps) {
  const [displayModal, setDisplayModal] = useState(false)
  const { downloadAllMonthlyInvoicesMutation } = useDownloadAllMonthlyInvoices()

  const onDownloadAllMonthlyInvoices = () => {
    downloadAllMonthlyInvoicesMutation.mutateAsync()
  }

  return (
    <div className={cn("flex min-w-250 grow flex-col gap-4", className)} {...props}>
      <div className="flex flex-row gap-4">
        <TransactionsResumeCard />
        <TransactionsMyWalletCard />
        <UserPromotionCodeCard />
      </div>

      <div className="flex flex-row flex-wrap items-center justify-between gap-2 md:gap-1 xl:flex-row">
        <TransactionTableFilter />

        <DropdownMenu>
          <DropdownMenuTrigger
            render={
              <Button variant="secondary" size="md" disabled={downloadAllMonthlyInvoicesMutation.isPending}>
                <DownloadIcon color="currentColor" size={16} />
                {word("global.download")}
                <ChevronDownIcon color="currentColor" size={16} />
                {downloadAllMonthlyInvoicesMutation.isPending && <LoadingSpinner />}
              </Button>
            }
          />
          <DropdownMenuContent className="mr-4 w-fit">
            <DropdownMenuItem onClick={() => void onDownloadAllMonthlyInvoices()}>
              {word("finances.page.export.allInvoices")}
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => setDisplayModal(true)}>
              {word("finances.page.export.listOfTransactions")}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      <Suspense fallback={<LoadingSpinner />}>
        <UserTransactionsTable />
      </Suspense>

      <ExportModal onHide={() => setDisplayModal(false)} visible={displayModal} financeApiType={ApiFinanceType.USER} />
    </div>
  )
}
